import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Checkbox } from 'antd';

class CheckboxInput extends Component {
  @autobind
  onCheckboxChange(e) {
    const { input: { onChange } } = this.props;
    onChange(e.target.checked);
  }

  render() {
    const { input, label, disabled } = this.props;
    return (
      <Checkbox
        checked={!!input.value}
        onChange={this.onCheckboxChange}
        disabled={disabled}
      >
        {label}
      </Checkbox>
    );
  }
}

CheckboxInput.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func,
  }),
  label: PropTypes.any,
  disabled: PropTypes.bool,
};

export default CheckboxInput;
